import {submitCustomerOffer} from "@project/sdk/sales";
import {SubmitCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function submitCustomerOfferMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.submitCustomerOffer,
    mutationFn: async (id: string) =>
      SubmitCustomerOfferResponse.parse(await submitCustomerOffer(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
